export const SET_RESOURCE_ACTIVATED_COLS = 'SET_RESOURCE_ACTIVATED_COLS';

export const resourceActions = {
  setActivatedColumns: (activatedColumns) => ({
    type: SET_RESOURCE_ACTIVATED_COLS,
    payload: activatedColumns
  })
};
